import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbModalRef, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-verify-product-modal',
  templateUrl: './verify-product-modal.component.html',
  styleUrls: ['./verify-product-modal.component.scss']
})
export class VerifyProductModalComponent implements OnInit {

  isProduct = true;
  @Input() productArray = [];
  closeResult: string;
  modalRef: NgbModalRef;
  @ViewChild('content') content;

  constructor(
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    // this.logService.printLog("Product array in modal - ", this.productArray);
  }

  open() {
    this.modalService.open(this.content, {size: 'lg'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/verify-product-modal/verify-product-modal.component.ts